import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { GlobalLoader, Text } from '@components';
import { ROUTES } from '@constants';
import { FormActionType, FormType, Translation, UserEndpoint } from '@enums';
import { useAppDispatch } from '@hooks';
import { submitFormRequest, updateFormProcedure } from '@store';

export const VerifyEmail: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const formType = FormType.User;

  const { t: tTabs } = useTranslation(Translation.SignIn, { keyPrefix: 'tab' });

  const [searchParams] = useSearchParams();

  const email = searchParams.get('email');
  const token = searchParams.get('token');

  useEffect(() => {
    if (email && token) {
      dispatch(updateFormProcedure({ formType, procedure: FormActionType.Verification }));
      dispatch(
        submitFormRequest({
          formType,
          params: { email, token },
          globalOptions: {
            endPath: true,
            endpoint: UserEndpoint.VERIFY_EMAIL,
            refetchAnywhere: true,
          },
          callbackFunction: {
            refetch: () => navigate(ROUTES.login),
          },
        }),
      );
    }
    if (!email || !token) {
      navigate(ROUTES.login);
    }
  }, [email, token]);

  return (
    <div className="space-y-10 pb-4 place-items-center">
      <Text $level={2} color="text-white">
        {tTabs('verifyingYourEmailAddress')}
      </Text>
      <GlobalLoader color="white" />
    </div>
  );
};
